import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PlanDocument from "@/pages/PlanDocument";
import { Gate } from "@/components/Gate";

function App() {
  return (
    <BrowserRouter>
      <Gate>
        <Routes>
          <Route path="*" element={<PlanDocument />} />
        </Routes>
      </Gate>
    </BrowserRouter>
  );
}

export default App;
